import { pushDigitalData } from '@/utils/digitalData';
import { favoriteItem } from '@/utils/formatters/formattedDigitalDataManager';

const useWishList = () => {
  /**
   * @param {Object} productInfo
   * @param {number|string} productInfo.id
   * @param {number|string} productInfo.price
   * @param {number|string} productInfo.oldPrice
   * @param {string} type
   */
  const toggleFavorite = (productInfo, type) => {
    pushDigitalData(favoriteItem(productInfo, type));
  };

  return { toggleFavorite };
};

export default useWishList;
